import(/* webpackMode: "eager" */ "C:\\dev\\okmoney\\src\\app\\risk-simulation\\page.tsx");
